import { Link } from "react-router-dom";
import "./ProductCategories.css";

import glucose from "../../assets/products/biscuits/gulcose biscuit.png";
import nice from "../../assets/products/biscuits/nice biscuit.png";
import milk from "../../assets/products/biscuits/milk biscuit.png";
import marie from "../../assets/products/biscuits/marie day biscuit.png";
import digestive from "../../assets/products/biscuits/digestive biscuit.png";

import chocolatecream from "../../assets/products/rectangle creams/rectangle chocolate biscuit.png";
import orangecream from "../../assets/products/rectangle creams/rectangle orange biscuit.png";
import strawberrycream from "../../assets/products/rectangle creams/rectangle strawberry biscuit.png";
import mangocream from "../../assets/products/rectangle creams/rectangle mango biscuit.png";
import pineapplecream from "../../assets/products/rectangle creams/rectangle pineapple biscuit.png";

import Chocolatecream from "../../assets/products/round creams/round chocolate biscuit.png";
import Orangecream from "../../assets/products/round creams/round orange biscuit.png";
import Strawberrycream from "../../assets/products/round creams/round strawberry biscuit.png";
import Mangocream from "../../assets/products/round creams/round mango biscuit.png";
import Pineapplecream from "../../assets/products/round creams/round pineapple biscuit.png";
import Loreocream from "../../assets/products/round creams/round lorio biscuit.png";

import ATCChocolatecream from "../../assets/products/atc/ATC CREAM chocolate.png";
import ATCOrangecream from "../../assets/products/atc/ATC CREAM orange.png";
import ATCStrawberrycream from "../../assets/products/atc/ATC CREAM strawberry.png";
import ATCMangocream from "../../assets/products/atc/ATC CREAM mango.png";
import ATCPineapplecream from "../../assets/products/atc/ATC CREAM pineapple.png";
import ATCVanillacream from "../../assets/products/atc/ATC CREAM venilla.png";
import ATCMilkcream from "../../assets/products/atc/ATC CREAM MILK.png";

import chocolate from "../../assets/products/crispy bites/chocolate.png";
import shortcake from "../../assets/products/crispy bites/short cake.png";
import shortbread from "../../assets/products/crispy bites/short bread.png";
import butter from "../../assets/products/crispy bites/butter.png";
import soda from "../../assets/products/crispy bites/soda.png";
import snacks from "../../assets/products/crispy bites/salted.png";
import mini from "../../assets/products/crispy bites/mini crackers.png";
import chocochip from "../../assets/products/crispy bites/Choco-Chip-Cookies.png";

import chocolatewaffer from "../../assets/products/waffers/chocolate waffer.png";
import orangewaffer from "../../assets/products/waffers/orange  waffer.png";
import strawberrywaffer from "../../assets/products/waffers/strawberry waffer.png";
import vanillawaffer from "../../assets/products/waffers/vanilla waffer.png";

import chocolateroll from "../../assets/products/rolls/chocolate rolls.png";
import orangeroll from "../../assets/products/rolls/orange rolls.png";
import strawberryroll from "../../assets/products/rolls/strawberry rolls.png";
import vanillaroll from "../../assets/products/rolls/vannila rolls.png";

import chocolatecone from "../../assets/products/cone/Fun cone chocolate.png";
import orangecone from "../../assets/products/cone/Fun cone orange.png";
import strawberrycone from "../../assets/products/cone/Fun cone strawberry.png";

const productGroups = [
  {
    title: "BISCUITS",
    products: [
      {
        name: "Glucose",
        image: glucose,
        show: "biscuits/glucose",
        textColor: "#004A67",
        productBgcolor: "#3DC9FF",
        alttag: "Glucose Biscuit",
      },
      {
        name: "Milk",
        image: milk,
        show: "biscuits/milk",
        textColor: "#0076D2",
        productBgcolor: "#0076D2",
        alttag: "Milk Biscuit",
      },
      {
        name: "Nice",
        image: nice,
        show: "biscuits/nice",
        textColor: "#004A67",
        productBgcolor: "#1AE0FF",
        alttag: "Nice Biscuit",
      },
      {
        name: "Marie Day",
        image: marie,
        show: "biscuits/marie",
        textColor: "#988200",
        productBgcolor: "#FFF0D9",
        alttag: "Marie Day Biscuit",
      },
      {
        name: "Digestive",
        image: digestive,
        show: "biscuits/digestive",
        textColor: "#A9090D",
        productBgcolor: "#FFECA9",
        alttag: "Digestive Biscuit",
      },
    ],
  },
  {
    title: "RECTANGLE CREAM",
    products: [
      {
        name: "Chocolate",
        image: chocolatecream,
        show: "rectangle-cream-biscuit/rectangle-chocolate",
        textColor: "#683B1E",
        productBgcolor: "#FFECCB",
        alttag: "Rectangle Chocolate Cream Biscuit",
      },
      {
        name: "Orange",
        image: orangecream,
        show: "rectangle-cream-biscuit/rectangle-orange",
        textColor: "#F05E28",
        productBgcolor: "#FFE2CF",
        alttag: "Rectangle Orange Cream Biscuit",
      },
      {
        name: "Strawberry",
        image: strawberrycream,
        show: "rectangle-cream-biscuit/rectangle-strawberry",
        textColor: "#C03976",
        productBgcolor: "#FFE5ED",
        alttag: "Rectangle Starwberry Cream Biscuit",
      },
      {
        name: "Mango",
        image: mangocream,
        show: "rectangle-cream-biscuit/rectangle-mango",
        textColor: "#F4B400",
        productBgcolor: "#FFF5D1",
        alttag: "Rectangle Mango Cream Biscuit",
      },
      {
        name: "Pineapple",
        image: pineapplecream,
        show: "rectangle-cream-biscuit/rectangle-pineapple",
        textColor: "#D6AE00",
        productBgcolor: "#FFFAD1",
        alttag: "Rectangle Pineapple Cream Biscuit",
      },
    ],
  },
  {
    title: "ROUND CREAM",
    products: [
      {
        name: "Chocolate",
        image: Chocolatecream,
        show: "round-cream-biscuit/round-chocolate",
        textColor: "#6F4E37",
        productBgcolor: "#FBEBD7",
        alttag: "Round Chocolate Cream Biscuit",
      },
      {
        name: "Orange",
        image: Orangecream,
        show: "round-cream-biscuit/round-orange",
        textColor: "#FF6B00",
        productBgcolor: "#FFE9D9",
        alttag: "Round Orange Cream Biscuit",
      },
      {
        name: "Strawberry",
        image: Strawberrycream,
        show: "round-cream-biscuit/round-strawberry",
        textColor: "#D9437D",
        productBgcolor: "#FFDDEB",
        alttag: "Round Strawberry Cream Biscuit",
      },
      {
        name: "Mango",
        image: Mangocream,
        show: "round-cream-biscuit/round-mango",
        textColor: "#FFB300",
        productBgcolor: "#FFF3D6",
        alttag: "Round Mango Cream Biscuit",
      },
      {
        name: "Pineapple",
        image: Pineapplecream,
        show: "round-cream-biscuit/round-pineapple",
        textColor: "#E6BE00",
        productBgcolor: "#FFFCE0",
        alttag: "Round Pineapple Cream Biscuit",
      },
      {
        name: "Loreo",
        image: Loreocream,
        show: "round-cream-biscuit/round-loreo",
        textColor: "#6EB9FF",
        productBgcolor: "#ddf5ff",
        alttag: "Round Loreo Cream Biscuit",
      },
    ],
  },
  {
    title: "ATC CREAM",
    products: [
      {
        name: "Chocolate",
        image: ATCChocolatecream,
        show: "atc/chocolate",
        textColor: "#6A3E20",
        productBgcolor: "#FFECCB",
        alttag: "ATC Chocolate Cream Biscuit",
      },
      {
        name: "Orange",
        image: ATCOrangecream,
        show: "atc/orange",
        textColor: "#EF5608",
        productBgcolor: "#FFC395",
        alttag: "ATC Orange Cream Biscuit",
      },
      {
        name: "Strawberry",
        image: ATCStrawberrycream,
        show: "atc/strawberry",
        textColor: "#FF009F",
        productBgcolor: "#FFD4F2",
        alttag: "ATC Strawberry Cream Biscuit",
      },
      {
        name: "Mango",
        image: ATCMangocream,
        show: "atc/mango",
        textColor: "#FF8D00",
        productBgcolor: "#FFDE85",
        alttag: "ATC Mango Cream Biscuit",
      },
      {
        name: "Pineapple",
        image: ATCPineapplecream,
        show: "atc/pineapple",
        textColor: "#40662B",
        productBgcolor: "#FFFCBD",
        alttag: "ATC Pineapple Cream Biscuit",
      },
      {
        name: "Vanilla",
        image: ATCVanillacream,
        show: "atc/vanilla",
        textColor: "#9F794D",
        productBgcolor: "#FFE6CB",
        alttag: "ATC Vanilla Cream Biscuit",
      },
      {
        name: "Milk",
        image: ATCMilkcream,
        show: "atc/milk",
        textColor: "#2C8AF9",
        productBgcolor: "#C4E5FF",
        alttag: "ATC Milk Cream Biscuit",
      },
    ],
  },
  {
    title: "CRISPY BITES",
    products: [
      {
        name: "Bourbon",
        image: chocolate,
        show: "crispy-biscuit/chocolate",
        textColor: "#4E342E",
        productBgcolor: "#F5E1DC",
        alttag: "Crispy Chocolate Biscuit",
      },
      {
        name: "Short Cake",
        image: shortcake,
        show: "crispy-biscuit/shortcake",
        textColor: "#FFCA28",
        productBgcolor: "#FFF8E1",
        alttag: "Crispy Short Cake",
      },
      {
        name: "Shortbread",
        image: shortbread,
        show: "crispy-biscuit/shortbread",
        textColor: "#D2B48C",
        productBgcolor: "#FFF5EC",
        alttag: "Crispy Short Bread",
      },
      {
        name: "Butter Cookies",
        image: butter,
        show: "crispy-biscuit/butter-cookies",
        textColor: "#09026B",
        productBgcolor: "#9790FF",
        alttag: "Crispy Butter Cookies",
      },
      {
        name: "Soda Crackers",
        image: soda,
        show: "crispy-biscuit/soda-crackers",
        textColor: "#5C2F00",
        productBgcolor: "#916B43",
        alttag: "Crispy Soda Crackers",
      },
      {
        name: "Salt Crackers",
        image: snacks,
        show: "crispy-biscuit/salt-biscuits",
        textColor: "#FFE5E2",
        productBgcolor: "#C03900",
        alttag: "Crispy Salt Biscuits",
      },
      {
        name: "Mini Crackers",
        image: mini,
        show: "crispy-biscuit/mini-crackers",
        textColor: "#E2A01D",
        productBgcolor: "#6A3E20",
        alttag: "Crispy Mini Crackers",
      },
      {
        name: "Choco Chip Cookies",
        image: chocochip,
        show: "crispy-biscuit/choco-chip-cookies",
        textColor: "#4E342E",
        productBgcolor: "#F5E1DC",
        alttag: "Crispy Choco Chip Cookies",
      },
    ],
  },
];

const waffers = [
  {
    name: "Chocolate",
    image: chocolatewaffer,
    show: "waffers/chocolate-waffer",
    textColor: "#5D4037",
    productBgcolor: "#F3E5AB",
    alttag: "Chocolate Waffers",
  },
  {
    name: "Strawberry",
    image: strawberrywaffer,
    show: "waffers/strawberry-waffer",
    textColor: "#FB8C00",
    productBgcolor: "#FFE3C1",
    alttag: "Strawberry Waffers",
  },
  {
    name: "Vanilla",
    image: vanillawaffer,
    show: "waffers/vannila-waffer",
    textColor: "#EC407A",
    productBgcolor: "#FFEBF1",
    alttag: "Vanilla Waffers",
  },
  {
    name: "Orange",
    image: orangewaffer,
    show: "waffers/orange-waffer",
    textColor: "#F3E5AB",
    productBgcolor: "#FFFDE7",
    alttag: "Orange Waffers",
  },
];

const rolls = [
  {
    name: "Chocolate",
    image: chocolateroll,
    show: "rolls/chocolate-roll",
    textColor: "#795548",
    productBgcolor: "#FBE9E7",
    alttag: "Chocolate Rolls",
  },
  {
    name: "Strawberry",
    image: strawberryroll,
    show: "rolls/strawberry-roll",
    textColor: "#EF6C00",
    productBgcolor: "#FFF3E0",
    alttag: "Strawberry Rolls",
  },
  {
    name: "Vanilla",
    image: vanillaroll,
    show: "rolls/vannila-roll",
    textColor: "#F06292",
    productBgcolor: "#FCE4EC",
    alttag: "Vanilla Rolls",
  },
  {
    name: "Orange",
    image: orangeroll,
    show: "rolls/orange-roll",
    textColor: "#FFF176",
    productBgcolor: "#FFFDE7",
    alttag: "Orange Rolls",
  },
];

const newproductGroups = [
  {
    title: "Waffer Cone",
    products: [
      {
        name: "Chocolate",
        image: chocolatecone,
        show: "cone/chocolate-cone",
        textColor: "#68171A",
        productBgcolor: "#FFECCB",
        alttag: "Chocolate Waffer Cone",
      },
      {
        name: "Orange",
        image: orangecone,
        show: "cone/orange-cone",
        textColor: "#FE4B00",
        productBgcolor: "#FFC9A3",
        alttag: "Orange Waffer Cone",
      },
      {
        name: "Strawberry",
        image: strawberrycone,
        show: "cone/strawberry-cone",
        textColor: "#FF009F",
        productBgcolor: "#FFA3C4",
        alttag: "Strawberry Waffer Cone",
      },
    ],
  },
];

export default function ProductCategories() {
  const renderProductCard = (item) => (
    <Link
      key={item.show}
      to={`/${item.show}`}
      className="product-card"
      style={{ cursor: "pointer", background: item.productBgcolor }}>
      <img src={item.image} alt={item.alttag} />
      <div className="product-name">
        <h3 style={{ color: item.textColor }}>{item.name}</h3>
      </div>
    </Link>
  );

  return (
    <section className="product-categories">
      {productGroups.map((group, i) => (
        <div className={`category-section section-${i}`} key={`grp-${i}`}>
          <div className="container">
            <h2 className="category-title">{group.title}</h2>
            <div className="product-grid">
              {group.products.map(renderProductCard)}
            </div>
          </div>
        </div>
      ))}

      <div className="category-section waffer-rolls">
        <div className="container">
          <div className="waffer-rolls-container">
            <div className="waffer-section">
              <h2 className="section-title">WAFFER</h2>
              <div className="product-grid">
                {waffers.map(renderProductCard)}
              </div>
            </div>
            <div className="rolls-section">
              <h2 className="section-title">ROLLS</h2>
              <div className="product-grid">{rolls.map(renderProductCard)}</div>
            </div>
          </div>
        </div>
      </div>

      {newproductGroups.map((group, i) => (
        <div className={`category-section section-${i}`} key={`newgrp-${i}`}>
          <div className="container">
            <h2 className="category-title">{group.title}</h2>
            <div className="product-grid">
              {group.products.map(renderProductCard)}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}
